import { render, staticRenderFns } from "./bidEvaluationMethod.vue?vue&type=template&id=36e5a7b0&scoped=true"
import script from "./bidEvaluationMethod.vue?vue&type=script&lang=js"
export * from "./bidEvaluationMethod.vue?vue&type=script&lang=js"
import style0 from "./bidEvaluationMethod.vue?vue&type=style&index=0&id=36e5a7b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e5a7b0",
  null
  
)

export default component.exports